"use strict";
exports.roundToNearestHours = roundToNearestHours;
var _index = require("./_lib/getRoundingMethod.js");
var _index2 = require("./constructFrom.js");
var _index3 = require("./toDate.js");
function roundToNearestHours(date, options) {
  var _a, _b;
  const nearestTo = (_a = options == null ? void 0 : options.nearestTo) != null ? _a : 1;
  if (nearestTo < 1 || nearestTo > 12)
    return (0, _index2.constructFrom)(date, NaN);
  const _date = (0, _index3.toDate)(date);
  const fractionalMinutes = _date.getMinutes() / 60;
  const fractionalSeconds = _date.getSeconds() / 60 / 60;
  const fractionalMilliseconds = _date.getMilliseconds() / 1e3 / 60 / 60;
  const hours = _date.getHours() + fractionalMinutes + fractionalSeconds + fractionalMilliseconds;
  const method = (_b = options == null ? void 0 : options.roundingMethod) != null ? _b : "round";
  const roundingMethod = (0, _index.getRoundingMethod)(method);
  const roundedHours = roundingMethod(hours / nearestTo) * nearestTo;
  const result = (0, _index2.constructFrom)(date, _date);
  result.setHours(roundedHours, 0, 0, 0);
  return result;
}
